import { Seo } from '../components/Seo';
import { Icon } from '../components/Icon';
import { TransactionSupportCard } from '../components/TransactionSupportCard';
import { SITE, buildTitle } from '../lib/site';
import { useT } from '../i18n';

export function ContactPage() {
  const t = useT();
  const p = t.pages.contact;
  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.lead}
        path="/contact"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{p.lead}</p>
        </div>
      </section>

      <section className="section">
        <div className="container container-narrow">
          <TransactionSupportCard
            eyebrow={p.transactionSupportEyebrow}
            title={p.transactionSupportTitle}
            description={p.transactionSupportDesc}
            cta={p.transactionSupportCta}
          />

          <div className="contact-grid">
            <div>
              <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 20, color: 'var(--text-strong)', marginBottom: 16 }}>
                {p.support}
              </h3>
              <a href={`mailto:${SITE.email}`} className="contact-channel">
                <div className="icon"><Icon name="mail" /></div>
                <div>
                  <div className="label">{p.email}</div>
                  <div className="value">{SITE.email}</div>
                </div>
              </a>
            </div>

            <div>
              <div className="card" style={{ height: '100%' }}>
                <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 20, color: 'var(--text-strong)', marginBottom: 16 }}>
                  {p.beforeTitle}
                </h3>
                <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 14 }}>
                  {p.before.map((item) => (
                    <li key={item} style={{ display: 'flex', gap: 10, alignItems: 'flex-start', color: 'var(--text-muted)', fontSize: 14.5, lineHeight: 1.6 }}>
                      <Icon name="check" width={18} height={18} style={{ color: 'var(--mint)', flexShrink: 0, marginTop: 3 }} />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <div className="callout" style={{ marginTop: 24, marginBottom: 0 }}>
                  <div className="title">{p.securityTitle}</div>
                  <p>{p.securityDesc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
